import { LOADING_LOCATIONS, SET_LOCATIONS } from '../constants/action-types';
export const DEFAULT_STATE = false;
// eslint-disable-next-line @typescript-eslint/default-param-last
export const isLoading = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_LOCATIONS:
            return false;
        case LOADING_LOCATIONS:
            return true;
        default:
            return state;
    }
};
